import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { voyageCrew } from '../voyageCrew-sidecar'
import { voyageMultiplayerCursors } from '../voyageMultiplayerCursors-sidecar'
import { voyagePicker } from '../voyagePicker-sidecar'
import { EVoyageMessage } from './voyageMessageIds'

export interface IMessageCrewSelected {
  // multiId: number
  crewId: number
}

export const voyageMessageId = EVoyageMessage.CrewSelected

export function write(m: IMessageWriter, d: IMessageCrewSelected) {
  messageWriter.write8(m, voyageMessageId)
  // messageWriter.write16(m, d.multiId)
  messageWriter.write32(m, d.crewId)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)
  let d: IMessageCrewSelected = {
    // multiId: messageWriter.read16(m),
    crewId: messageWriter.read32(m),
  }
  return d
}

export function test() {
  let ex: IMessageCrewSelected = {
    // multiId: 100,
    crewId: 120,
  }
  messageWriter.test('crew-selected', ex, write, read)
}

export function process(m: IMessageWriter, isFromHost: boolean, from: number) {
  let msg = read(m)
  let cur = voyageMultiplayerCursors.findByMultiIdSafe(from)
  let cr = voyageCrew.findByIdSafe(msg.crewId)
  voyageMultiplayerCursors.networkRecieveSelectCrew(cur, cr)

  if (voyagePicker.get().selectedCrew === cr) {
    voyagePicker.clearSelection()
  }
}

export function sendToOthers(msg: IMessageCrewSelected) {
  websockets._sendMessageToOthers(write, msg)
}
